<template lang="es">
    <div>
         <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                       Municipalidades
                    </v-col>
                    <!--<v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Crear nueva
                        </v-btn>
            
                    </v-col> -->
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12">
                        <v-select
                            v-model="departamentoId"
                            :items="departamentos"
                            class="required"
                            dense
                            outlined
                            :loading="dialogLoaderVisible"
                            label="Departamento"
                            :item-text="item => `${item.codigo} - ${item.nombreDepartamento}`"
                            item-value="id"
                            :rules="[
                                selectRequired(
                                    'Departamento'
                                )
                            ]"
                            menu-props="auto"
                            @change="obtnenerItems();"
                        >
                        </v-select>
                    </v-col>

                     <v-col cols="12" md="6" sm="6" xs="12">
                        <v-text-field
                            outlined
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                        :headers="headers"
                        :items="municipios"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :items-per-page="10"
                        :search="tableFilter"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                             pageText: '{0}-{1} de {2}' 
                        }"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <!--<td>{{ item.id }}</td>-->
                            <td>{{ item.codigo }}</td>
                            <td>{{ item.nombreMunicipio }}</td>
                            <!--<td>{{ item.pais }}</td>-->
                            
                            <td>
                                <v-chip
                                    class="ma-2"
                                    :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                    text-color="white"
                                    small
                                >
                                    {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>

                                <!--<v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-account-plus</v-icon> Asignar revisor
                                </v-btn>-->
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la etnia-->
    <v-dialog
        v-model="dialog"
        max-width="700px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosMunicipio.departamentosId"
                                :items="departamentos"
                                class="required"
                                dense
                                outlined
                                :loading="dialogLoaderVisible"
                                label="Departamento"
                                item-text="nombreDepartamento"
                                item-value="id"
                                :rules="[
                                    selectRequired('Departamento'),
                                ]"
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosMunicipio.nombreMunicipio"
                                label="Nombre de la municipalidad"
                                hint="Ej: Las Flores"
                                :rules="[
                                    required('Municipio'),
                                    alphaRule('Municipio'),
                                    minLength('Municipio', 3)
                                ]"
                                maxlength="50"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                     <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosMunicipio.codigo"
                                label="Código del municipio"
                                :rules="[
                                    required('Código del municipio'),
                                    onlyInteger('Código del municipio')
                                ]"
                                maxlength="5"
                                v-mask="'#####'"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la etnia-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_MUNICIPIOS_POR_DEPTO, OBTENER_MUNICIPIO, REGISTRAR_MUNICIPIO, ACTUALIZAR_MUNICIPIO } from "@/core/services/store/catalogos/municipio.module";
//import { OBTENER_DEPARTAMENTOS } from "@/core/services/store/catalogos/departamento.module";
import { OBTENER_DEPARTAMENTOS } from "@/core/services/store/catalogos/departamento.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AdminMunicipios",
    components: {
    SnackAlert,
    DialogLoader
    },
        data() {
        return {
            validForm:false,
            itemName : "Municipalidades",
            dialog: false,
            modalTitle: 'Registrar Municipalidad',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Municipalidad',
            accion: 1,
            Pais_Id: 0,
            municipios: [],
            tableFilter:'',
            departamentos: [],
            departamentoId:0,
            switchItemEstado: true,
            datosMunicipio: {
                id: 0,
                nombreMunicipio: '',     
                usuarioCreacion: 'admin',   
                fechaCreacion: '2021-07-23', 
                usuarioActualizacion: '',
                fechaActualizacion: '2021-07-23', 
                departamentosId: 1,
                estadosId: 1,
                codigo:'',
            },
            datosDepartamento: {
                id: 0,
                nombreDepto: '',
                pais_Id: 1,
                fechaCreacion: '2021-07-23', 
                usuarioCreacion: 'admin',
                fechaActualizacion: '2021-07-23', 
                usuarioActualizacion: '',
                estadosId: 1,
            },
            
            tableLoading: false,
            ...validations
        } 
    },
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Municipalidad';
            this.btnRegistroText='Registrar Municipalidad';
            this.dialog=true;
        },

        resetForm(){
            //this.$refs.form.reset();
            this.datosMunicipio={
                id: 0,
                nombreMunicipio: '',     
                usuarioCreacion: 'admin',   
                fechaCreacion: '2021-07-23', 
                usuarioActualizacion: '',
                fechaActualizacion: '2021-07-23', 
                departamentosId: 1,
                estadosId: 1,
                codigo:'',
            };
            this.switchItemEstado = true;
        },

       
        //!Obtener los municipios registrados
        obtnenerItems(){
            this.datosMunicipio.departamentoId = this.departamentoId;
            this.tableLoading = true;
            this.municipios=[];
            
            this.$store
                .dispatch(OBTENER_MUNICIPIOS_POR_DEPTO, {departamentoId:this.departamentoId})
                .then(res => {
                    if(res.status==200){
                        this.municipios = this.$store.state.municipio.municipios;
                    }
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

       

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosMunicipio.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Municipalidad';
            this.btnRegistroText='Actualizar Municipalidad';

            this.$store
                .dispatch(OBTENER_MUNICIPIO, Id)
                .then(() => {
                    this.datosMunicipio = this.$store.state.municipio.municipio;
                    this.datosMunicipio.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                   
                    this.obtenerDepartamentos().then(()=>{
                        this.datosMunicipio.departamento_Id = this.datosDepartamento.id;
                        this.dialog = true;
                        this.dialogLoaderVisible = false;
                    });
                    
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                });
        },

        async obtenerDepartamentos(){
            this.departamentos=[];
            //this.dd=true;
            await
            this.$store
            .dispatch(OBTENER_DEPARTAMENTOS,1) //Obtener departamentos con el estado 1 (activo)
            .then(() => {

                this.departamentos = this.$store.state.departamento.departamentos;
               // this.dialogLoaderVisible = false;
                //console.log(this.departamentos)
            })
            .catch(() => {});
        },
        
        registrarItem(){
            //console.log(this.accion)
            
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosMunicipio.estadosId = 1 : this.datosMunicipio.estadosId = 2;

            if(this.accion===1){
                this.datosMunicipio.id = 0;
                this.$store
                    .dispatch(REGISTRAR_MUNICIPIO, this.datosMunicipio)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_MUNICIPIO, this.datosMunicipio)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Catalogos" },
            { title: "Municipalidades" }
        ]);
    },

    created(){
        //this.obtnenerItems();
        this.obtenerDepartamentos();
        
    },

    computed: {
        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                {
                    text: "Código del municipio",
                    value: "codigo"
                },
                {
                    text: "Nombre del municipio",
                    value: "nombreMunicipio"
                },
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="">
    
</style>